<div class="mydocma-dialog-container mm-kb-scroll-footer">
  <div *ngIf="!(appContainerService.mobileView$ | async); else mobileHeader" class="mydocma-dialog-header">
    <div class="mydomca-dialog-header-title" *ngIf="this.dialogData.config.selectedTemplate as t; else noTemplateHeader">
      {{'MM.report.title' | translate}}:
      {{t.Number}} {{t.Number > 0  && t.Name1 ? '-' : ''}} {{t.Name1}}
    </div>
    <ng-template #noTemplateHeader>
      <div class="mydomca-dialog-header-title">
        {{'MM.report.title' | translate}}
      </div>
    </ng-template>
    <div>
      <button mat-icon-button type= "button" mat-dialog-close>
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="mydocma-dialog-body">
    <div class="wt-dialog-content"
    [@.disabled]="isAnimationUnsupportedDevice"
    [class.anim-off]="isAnimationUnsupportedDevice"
    mydocmaResizeEvent 
    (resize)="onResize($event)">
      <mydocma-loader class="mydocma-mm-loader" [size]="'middle'" *ngIf="this.dialogData.service.loading$ | async"></mydocma-loader>
      <mydocma-mm-report-stepper 
      [@.disabled]="isAnimationUnsupportedDevice"
      [class.anim-off]="isAnimationUnsupportedDevice"
      #stepperComponent 
      [reportConfig] = "this.dialogData.config" 
      [mobileMode]="mobileMode">
      </mydocma-mm-report-stepper>
    </div>
  </div>

  <div *ngIf="!(appContainerService.mobileView$ | async); else mobileFooter" class="mydocma-dialog-footer">

    <button (click)="dialogData?.config.previewModel?.loadState?.status === loadStatusEnum.Loaded ? downloadPreview() : createPreview()"
            class="mydocma-btn-secondary preview-button" style="margin-right: 10px;"
            matTooltip="{{'MM.report.previewTooltip' | translate}}"
            [disabled]="dialogData?.config?.previewModel?.loadState?.status === loadStatusEnum.Loading"
            mat-stroked-button *ngIf="(dialogData?.service?.stepperService?.currentStep$ | async)?.config.name === 'selectCreationType' ||
                                      (dialogData?.service?.stepperService?.currentStep$ | async)?.config.name === 'selectOptions'">
      {{(dialogData?.config.previewModel?.loadState?.status === loadStatusEnum.Loaded ? 'MM.report.downloadPreviewButton' : 'MM.report.createPreviewButton') | translate}}

      <mydocma-custom-mat-icon class="button-icon" [iconName]="'_pdf'" style="display: inline-flex"></mydocma-custom-mat-icon>
    </button>


    <button
      [disabled]="dialogData?.config?.previewModel?.loadState?.status === loadStatusEnum.Loading"

      mat-stroked-button type="submit" class="mydocma-btn" (click)="cancel()" style="margin-right: 10px">
      {{'MM.general.button.cancel' | translate}}
    </button>
    <button mat-stroked-button type="button" class="mydocma-btn-primary"
      [disabled]="!(this.dialogData.service.selectedTemplate$ | async) || dialogData?.config?.previewModel?.loadState?.status === loadStatusEnum.Loading" (click)="next()">
      {{(((dialogData?.service?.stepperService?.currentStep$ | async)?.config.name === 'selectCreationType' && dialogData.config.creationType === creationType.download) ?
      'MM.report.doneButton' :
      (dialogData?.service?.stepperService?.currentStep$ | async)?.config.name === 'selectEmail' ?
        'MM.report.sendButton' :
        'MM.report.nextButton') | translate }}
      </button>
  </div>

  <ng-template #mobileHeader>
    <div class="mydocma-dialog-header">
      <div class="mm-pane-header mydocma-detail-header" fxFlex="row" fxFlexAlign="center space-between" style="flex: 1 1 100%">
<!--        <button mat-stroked-button type="button" class="mydocma-btn-primary" [disabled]="!(this.dialogData.service.selectedTemplate$ | async)" (click)="next()">-->
<!--          {{(((dialogData?.service?.stepperService?.currentStep$ | async)?.config.name === 'selectCreationType' && dialogData.config.creationType === creationType.download) ?-->
<!--          'MM.report.doneButton' :-->
<!--          (dialogData?.service?.stepperService?.currentStep$ | async)?.config.name === 'selectEmail' ?-->
<!--            'MM.report.sendButton' :-->
<!--            'MM.report.nextButton') | translate }}-->
<!--                      <mat-icon>chevron_right</mat-icon>-->
<!--        </button>-->

        <div class="mm-pane-header-title" style="display: block">
          <div class="mm-pane-header-text" *ngIf="this.dialogData.config.selectedTemplate as t; else noTemplateMobileHeader">
            {{'MM.report.title' | translate}}: {{t.Number}} {{t.Number > 0  && t.Name1 ? '-' : ''}} {{t.Name1}}
          </div>
        </div>

        <ng-template #noTemplateMobileHeader>
          <div class="mm-pane-header-title">
            <div class="mm-pane-header-text">
              {{'MM.report.title' | translate}}
            </div>
          </div>
        </ng-template>

        <button
          style="display: block"
          mat-icon-button type="button" mat-dialog-close>
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </ng-template>

  <ng-template #mobileFooter>
    <div style="padding: 16px 0 16px 0;" class="mobile-pane-footer">
      <div
        style="margin-right: 10px"
        *ngIf="(dialogData?.service?.stepperService?.currentStep$ | async)?.config.name === 'selectCreationType' ||
                                  (dialogData?.service?.stepperService?.currentStep$ | async)?.config.name === 'selectOptions'">
        <button  (click)="dialogData?.config.previewModel?.loadState?.status === loadStatusEnum.Loaded ? downloadPreview() : createPreview()"
                 class="mydocma-btn-secondary preview-button" style="margin-right: 10px;"
                 matTooltip="{{'MM.report.previewTooltip' | translate}}"
                 [disabled]="dialogData?.config?.previewModel?.loadState?.status === loadStatusEnum.Loading"
                 mat-stroked-button >
          {{(dialogData?.config.previewModel?.loadState?.status === loadStatusEnum.Loaded ? 'MM.report.downloadPreviewButtonMobile' : 'MM.report.createPreviewButtonMobile') | translate}}
        </button>
      </div>
      <div style="margin-right: 10px">
        <button mat-stroked-button (click)="cancel()" class="mydocma-btn">
          {{'MM.general.button.cancel' | translate}}
        </button>
      </div>
      <div style="margin-right: 10px">
        <button mat-stroked-button type="button" class="mydocma-btn-primary" [disabled]="!(this.dialogData.service.selectedTemplate$ | async)" (click)="next()">
          {{(((dialogData?.service?.stepperService?.currentStep$ | async)?.config.name === 'selectCreationType' && dialogData.config.creationType === creationType.download) ?
          'MM.report.doneButton' :
          (dialogData?.service?.stepperService?.currentStep$ | async)?.config.name === 'selectEmail' ?
            'MM.report.sendButton' :
            'MM.report.nextButton') | translate }}
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>

    </div>
  </ng-template>
</div>
<ng-template>

</ng-template>
